// This file is included in production builds as the first entry point in the bundle.
// It must run before the rest of the bundle even executes, since it sets a variable that webpack uses
// to resolve dynamic imports.

// This variable is not global, it is a 'free' variable that is scoped to this bundle.
__webpack_public_path__ = window.___publicPath___; // eslint-disable-line
